import { init, showMessage } from '@ui/react-toastify-popup-adapter';

/**
 * init - This function initializes the toast container and styles.
 * showMessage - This function exports a showMessage function that displays a toast message with the given text and options.
 */
export { init, showMessage };
